import styled from "@emotion/styled";
import { List as MuiList } from "@mui/material";

const List = styled(MuiList)({
  padding: "52px 32px",
  margin: 0,
  width: "100%",
  maxWidth: "200px",
  "@media (max-width: 900px)": {
    maxWidth: "unset",
    width: "unset",
    padding: "0 16px",
  },
  border: "1px solid #CED5EC",
  borderRadius: "20px",
});

export default List;